<router-outlet></router-outlet>

<div kendoDialogContainer></div>

@if (isLoading$ | async) {
  <div class="loader-block overlay">
    <app-loader></app-loader>
  </div>
}
